import { CurrencyField } from "./CurrencyField";
import SortableEntryWrapper from "./SortableEntryWrapper";

interface LoanAmountEntryProps {
  id: string;
  index: number;
  value: number | undefined;
  onChange: (value: number) => void;
  onRemove: () => void;
  canRemove: boolean;
  autoFocus?: boolean;
}

export default function LoanAmountEntry({
  id,
  index,
  value,
  onChange,
  onRemove,
  canRemove,
  autoFocus,
}: LoanAmountEntryProps) {
  return (
    <SortableEntryWrapper id={id} onRemove={onRemove} canRemove={canRemove}>
      <CurrencyField
        label={`Mortgage Debt ${index + 1}`}
        value={value}
        onChange={onChange}
        fullWidth
        margin="none"
        required
        autoFocus={autoFocus}
        greaterThanZero
      />
    </SortableEntryWrapper>
  );
}
